import stylesheet from './Checkbox.scss?inline';

import {NXTBaseInput} from '../Input/Input';

export class NXTCheckbox extends NXTBaseInput {
    static observedAttributes = ['checked', 'disabled'];

    private input: HTMLInputElement;
    private box: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get value(): string {
        return this.input?.value ?? this.getAttribute('value') ?? '';
    }

    get checked(): boolean {
        return this.input ? this.input.checked : this.hasAttribute('checked');
    }

    set checked(checked: boolean) {
        if (checked) {
            this.setAttribute('checked', '');
        } else {
            this.removeAttribute('checked');
        }
    }

    render() {
        const label = document.createElement('label');
        label.classList.add('checkbox');

        const slottedInputs = this.getSlotElements('input').filter(
            (el): el is HTMLInputElement => el instanceof HTMLInputElement,
        );

        if (slottedInputs.length > 0) {
            this.input = slottedInputs[0];
        } else {
            const input = document.createElement('input');
            input.setAttribute('slot', 'input');
            input.checked = this.checked;
            input.disabled = this.hasAttribute('disabled');
            if (this.hasAttribute('value')) {
                input.value = this.getAttribute('value');
            }
            this.appendChild(input);
            this.input = input;
        }
        this.input.type = 'checkbox';

        label.innerHTML = `
            <slot name="input"></slot>
            <span class="box"></span>
            <span class="label"><slot></slot></span>
        `;
        this.box = label.querySelector('.box');

        label.addEventListener('click', (event) => {
            if (event.target === this.input) {
                return;
            }
            event.preventDefault();
            this.input.click();
        });

        this.input.addEventListener('change', () => {
            this.checked = this.input.checked;
            this.syncBox();
            this.dispatchEvent(new Event('change', {bubbles: true, composed: true}));
        });
        this.input.addEventListener('focus', () => this.box.classList.add('focus'));
        this.input.addEventListener('blur', () => this.box.classList.remove('focus'));

        this.syncBox();
        return label;
    }

    private syncBox() {
        this.box.classList.toggle('checked', this.input.checked);
        this.box.classList.toggle('disabled', this.input.disabled);
    }

    // noinspection JSUnusedGlobalSymbols
    attributeChangedCallback(name: string) {
        if (!this.input) {
            return;
        }
        if (name === 'checked') {
            this.input.checked = this.hasAttribute('checked');
        }
        if (name === 'disabled') {
            this.input.disabled = this.hasAttribute('disabled');
        }
        this.syncBox();
    }

}

customElements.define('nxt-checkbox', NXTCheckbox);
